export const resolvers = {
  Mutation: {


  }
}

export const defaults = {
  testingStatus: {
    __typename: 'TestingStatus',
    isTesting: true,
  },
  navStatus: {
    __typename: 'ShowNav',
    showNav: false,
  }
}



// WEBPACK FOOTER //
// ./src/localResolvers/resolvers.js